// extracted by mini-css-extract-plugin
export default {"embed":"embed-Ff6x"};